import { AxiosResponse } from 'axios';

import { Start } from './../pages/outlet-crew/Home.type';
import { axiosInstance } from './axios.config';
import { ResponseREST } from './response.type';

export const postStart = async (body: Start): Promise<ResponseREST> => {
	return axiosInstance
		.post('/api/stock-take-document/start', body)
		.then((res: AxiosResponse<ResponseREST>) => res.data)
		.catch((err) => err);
};
